package com.bikompanion.ui.composables

import androidx.compose.runtime.Composable

/**
 * Opens directions using the best integration available on the current platform.
 *
 * Android uses an implicit `geo:` intent, so the user's installed/default maps app handles it.
 * Desktop and web use a standard maps URL because they don't have an equivalent maps-app intent.
 */
@Composable
internal expect fun rememberDirectionsLauncher(
    latitude: Double,
    longitude: Double,
    label: String,
): () -> Unit

internal fun webDirectionsUrl(
    latitude: Double,
    longitude: Double,
): String = "https://www.google.com/maps/dir/?api=1&destination=$latitude,$longitude"
